import { withCurrentParams } from 'actions/utils';
import { BROADCAST_START_RECORDINGS } from 'actions/Types';
import { BROADCAST_RECORDING_START } from 'store/eventConstants';

export default recordings => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, _, socket) => {
      const action = {
        type: BROADCAST_START_RECORDINGS,
        request: async apiClient => {
          const response = await apiClient.broadcast.startRecordings(
            teamId,
            eventId,
            broadcastId,
            {
              recordings
            }
          );
          // notify other directors
          socket.emit(BROADCAST_RECORDING_START, { broadcastId });
          return response;
        }
      };
      dispatch(action);
    }
  );
};
